const CloseIcon = ({ className = 'h-4 w-4', ...props }) => (
    <svg
        aria-hidden
        className={className}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M18 6 6 18M6 6l12 12" />
    </svg>
);

export { CloseIcon };
